<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'openCanceled']);
const { t } = useI18n();
</script>

<template>
  <div>
    <aside
      v-if="show"
      class="fixed inset-x-3 bottom-3 z-[var(--z-index-modal)] ml-auto w-auto max-w-md rounded-lais border border-lais-border bg-white p-4 shadow-lais-pop sm:inset-x-auto sm:right-6 sm:bottom-6"
      role="status"
      aria-live="polite"
    >
      <div class="flex items-start justify-between gap-4">
        <div class="min-w-0">
          <p class="font-semibold text-lais-text">
            {{ t('REAL_ESTATE_FINANCE.CANCELLATION_FEEDBACK.TITLE') }}
          </p>
          <p class="mt-1 text-sm text-lais-text-muted">
            {{ t('REAL_ESTATE_FINANCE.CANCELLATION_FEEDBACK.DESCRIPTION') }}
          </p>
        </div>
        <button
          type="button"
          class="grid size-8 shrink-0 place-items-center rounded-full text-lais-text-muted hover:bg-lais-primary-50"
          :aria-label="t('REAL_ESTATE_FINANCE.ACTIONS.CLOSE')"
          @click="emit('close')"
        >
          <span class="i-lucide-x size-4" aria-hidden="true" />
        </button>
      </div>
      <div class="mt-4 flex flex-wrap justify-end gap-2">
        <LaisPrimaryButton variant="ghost" size="sm" @click="emit('close')">
          {{ t('REAL_ESTATE_FINANCE.CANCELLATION_FEEDBACK.CONTINUE') }}
        </LaisPrimaryButton>
        <LaisPrimaryButton size="sm" @click="emit('openCanceled')">
          {{ t('REAL_ESTATE_FINANCE.CANCELLATION_FEEDBACK.VIEW_CANCELED') }}
        </LaisPrimaryButton>
      </div>
    </aside>
  </div>
</template>
